'use client';
import { useMemo } from 'react';

import { useHasSubscription } from '~features/tags';
import { useSession } from '~hooks/useSession';
import { useBalanceQuery } from '~services/api/credits';

import { AccountContext } from './index';

export const AccountContextProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const { userId, isDemoUser } = useSession();
	const {
		data,
		isLoading: balanceLoading,
		isSuccess,
	} = useBalanceQuery({ id: userId }, { skip: !userId || isDemoUser });
	const [hasSubscription, tagsLoading] = useHasSubscription();

	const value = useMemo(
		() => ({
			hasSubscription,
			balance: data?.balance ?? 0,
			loading: balanceLoading || tagsLoading,
			isSuccess,
		}),
		[hasSubscription, data?.balance, balanceLoading, tagsLoading, isSuccess]
	);

	return (
		<AccountContext.Provider value={value}>{children}</AccountContext.Provider>
	);
};
